import { stringify } from 'qs';
import {URL_API} from "../../../url.config";
import {request} from "../../../utils/apiUtils";
let OfficerController = {
    getList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    addYear: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/officer/add-year/${payload.yearId}?schoolId=${payload.schoolId}`,
            method: 'GET'
        }, callback)
    }
}
export default OfficerController
